var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3979 9.88H1.20421V0.602105C1.20421 0.273684 0.930526 0 0.602105 0C0.273684 0 0 0.273684 0 0.602105V10.4821C0 10.8105 0.273684 11.0842 0.602105 11.0842H12.3979C12.7263 11.0842 13 10.8105 13 10.4821C13 10.1537 12.7263 9.88 12.3979 9.88Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.60159 8.75768C2.69738 8.82611 2.80686 8.85347 2.93001 8.85347C3.13528 8.85347 3.32686 8.75768 3.43633 8.57979L5.43422 5.43242L7.37738 6.664C7.65107 6.8419 8.03422 6.75979 8.21212 6.47242L10.2374 3.27032L10.8805 3.68084C11.1269 3.83137 11.4416 3.65347 11.4279 3.36611L11.3458 0.944C11.3321 0.697684 11.0721 0.533474 10.8532 0.629263L8.62264 1.58716C8.36265 1.69663 8.33528 2.06611 8.56791 2.21663L9.21107 2.62716L7.50054 5.32295L5.55738 4.09137C5.27001 3.91347 4.90054 3.99558 4.72265 4.28295L2.41001 7.92295C2.23212 8.19663 2.31422 8.57979 2.60159 8.75768Z",
    fill: "black"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.6af44762b22305569643978a4a60e5f4.svg";
export { ForwardRef as ReactComponent };